import { parseNumber } from '../../utils/number.utils';
import { PendingOrders } from '../pending-orders';
import { PendingOrderBuilder } from './pending-order.builder';

export class PendingOrdersBuilder {
  static fromJson(json) {
    return (json)
      ? new PendingOrders(
        PendingOrderBuilder.fromList(json.pendingOrders),
        parseNumber(json.totalPage),
        parseNumber(json.total)
      )
      : null;
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/pending-orders.builder.ts